import { render, staticRenderFns } from "./CommentConfigurator.vue?vue&type=template&id=45651676&scoped=true&"
import script from "./CommentConfigurator.vue?vue&type=script&lang=js&"
export * from "./CommentConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./CommentConfigurator.vue?vue&type=style&index=0&id=45651676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45651676",
  null
  
)

export default component.exports